<template>
  <div class="single-obituary-global-comment-modal">
    <single-comment-modal
      v-if="comment"
      :is-landing-page="isLandingPage"
      :comment="comment"
      :context="context"
      :hash="hash"
      :deceased-name="deceasedName"
      :possessive-name="possessiveName"
      :memorial-fund="memorialFund"
      :is-new="isNew"
      :disabled="false"
      :modal-open="isOpen"
      :toggle-modal="toggleModal"
      :change-modal-context="changeContext"
      :open-lightbox="openLightbox"
      :reset-is-new="resetIsNew"
    />
  </div>
</template>

<script>
  import { mapActions, mapState } from "vuex";
  import SingleCommentModal from "./SingleCommentModal.vue";

  export default {
    name: "GlobalSingleCommentModal",

    components: { SingleCommentModal },

    provide() {
      return {
        timelineEnabled: this.$mountEl?.dataset?.timelineEnabled === 'true',
      };
    },

    computed: {
      ...mapState("singleCommentModal", [
        "isOpen",
        "context",
        "comment",
        "hash",
        "isNew",
        "isLandingPage",
        "deceasedName",
        "possessiveName",
        "memorialFund",
      ]),
    },

    methods: {
      ...mapActions("singleCommentModal", {
        closeModal: "close",
        changeContext: "changeContext",
        resetIsNew: "resetIsNew",
      }),

      // Inner content components (Edit/Delete/Share) only call toggleModal()
      // to close the modal — opening always goes through the store action.
      toggleModal() {
        this.closeModal();
      },

      // Lightbox UI was removed; keep the no-op so child components can still
      // wire `:open-lightbox` without throwing.
      openLightbox() {},
    },
  };
</script>
